/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntermediaryClientRelationshipViewModel
 */
export interface IntermediaryClientRelationshipViewModel {
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    bookOfBusinessCode: string;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    effectiveStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    effectiveEndDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    intermediaryCode: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    clientNumber: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    planNumber: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    investmentName: string;
    /**
     * 
     * @type {Date}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    inceptionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    planActiveFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    productType?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    productCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    productProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    jockeyFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    serviceFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof IntermediaryClientRelationshipViewModel
     */
    exBrokerFlag?: string;
}

/**
 * Check if a given object implements the IntermediaryClientRelationshipViewModel interface.
 */
export function instanceOfIntermediaryClientRelationshipViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bookOfBusinessCode" in value;
    isInstance = isInstance && "intermediaryCode" in value;
    isInstance = isInstance && "clientNumber" in value;
    isInstance = isInstance && "planNumber" in value;
    isInstance = isInstance && "investmentName" in value;

    return isInstance;
}

export function IntermediaryClientRelationshipViewModelFromJSON(json: any): IntermediaryClientRelationshipViewModel {
    return IntermediaryClientRelationshipViewModelFromJSONTyped(json, false);
}

export function IntermediaryClientRelationshipViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryClientRelationshipViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookOfBusinessCode': json['BookOfBusinessCode'],
        'effectiveStartDate': !exists(json, 'EffectiveStartDate') ? undefined : (new Date(json['EffectiveStartDate'])),
        'effectiveEndDate': !exists(json, 'EffectiveEndDate') ? undefined : (new Date(json['EffectiveEndDate'])),
        'intermediaryCode': json['IntermediaryCode'],
        'clientNumber': json['ClientNumber'],
        'planNumber': json['PlanNumber'],
        'investmentName': json['InvestmentName'],
        'inceptionDate': !exists(json, 'InceptionDate') ? undefined : (new Date(json['InceptionDate'])),
        'planActiveFlag': !exists(json, 'PlanActiveFlag') ? undefined : json['PlanActiveFlag'],
        'productCode': !exists(json, 'ProductCode') ? undefined : json['ProductCode'],
        'productName': !exists(json, 'ProductName') ? undefined : json['ProductName'],
        'productType': !exists(json, 'ProductType') ? undefined : json['ProductType'],
        'productCategory': !exists(json, 'ProductCategory') ? undefined : json['ProductCategory'],
        'productProvider': !exists(json, 'ProductProvider') ? undefined : json['ProductProvider'],
        'jockeyFlag': !exists(json, 'JockeyFlag') ? undefined : json['JockeyFlag'],
        'serviceFlag': !exists(json, 'ServiceFlag') ? undefined : json['ServiceFlag'],
        'exBrokerFlag': !exists(json, 'ExBrokerFlag') ? undefined : json['ExBrokerFlag'],
    };
}

export function IntermediaryClientRelationshipViewModelToJSON(value?: IntermediaryClientRelationshipViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BookOfBusinessCode': value.bookOfBusinessCode,
        'EffectiveStartDate': value.effectiveStartDate === undefined ? undefined : (value.effectiveStartDate.toISOString()),
        'EffectiveEndDate': value.effectiveEndDate === undefined ? undefined : (value.effectiveEndDate.toISOString()),
        'IntermediaryCode': value.intermediaryCode,
        'ClientNumber': value.clientNumber,
        'PlanNumber': value.planNumber,
        'InvestmentName': value.investmentName,
        'InceptionDate': value.inceptionDate === undefined ? undefined : (value.inceptionDate.toISOString()),
        'PlanActiveFlag': value.planActiveFlag,
        'ProductCode': value.productCode,
        'ProductName': value.productName,
        'ProductType': value.productType,
        'ProductCategory': value.productCategory,
        'ProductProvider': value.productProvider,
        'JockeyFlag': value.jockeyFlag,
        'ServiceFlag': value.serviceFlag,
        'ExBrokerFlag': value.exBrokerFlag,
    };
}

